"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Keycloak
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenToJSON = exports.TokenFromJSONTyped = exports.TokenFromJSON = void 0;
function TokenFromJSON(json) {
    return TokenFromJSONTyped(json, false);
}
exports.TokenFromJSON = TokenFromJSON;
function TokenFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'accessToken': json['access_token'],
        'expiresIn': json['expires_in'],
        'refreshExpiresIn': json['refresh_expires_in'],
        'refreshToken': json['refresh_token'],
        'tokenType': json['token_type'],
        'notBeforePolicy': json['not-before-policy'],
        'sessionState': json['session_state'],
        'scope': json['scope'],
    };
}
exports.TokenFromJSONTyped = TokenFromJSONTyped;
function TokenToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'access_token': value.accessToken,
        'expires_in': value.expiresIn,
        'refresh_expires_in': value.refreshExpiresIn,
        'refresh_token': value.refreshToken,
        'token_type': value.tokenType,
        'not-before-policy': value.notBeforePolicy,
        'session_state': value.sessionState,
        'scope': value.scope,
    };
}
exports.TokenToJSON = TokenToJSON;
//# sourceMappingURL=Token.js.map